import { useStore } from 'zustand';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { ResultOption } from './result-option.component';

import {
  clearRecentSearches,
  userLocationStore,
} from '@/store/user-location.store';
import { AutocompletePrediction } from '@/types/google-maps.types';
import { Typography } from '@/components/ui/typography/typography.component';
import { Button } from '@/components/ui/button/button.component';

export type RecentSearchedLocationsProps = {
  handleLocationClick: (item: AutocompletePrediction) => Promise<void>;
  callback: () => void;
};

export const RecentSearchedLocations = ({
  handleLocationClick,
  callback,
}: RecentSearchedLocationsProps) => {
  const recentSearches = useStore(
    userLocationStore,
    (state) => state.recentLocationSearches,
  );

  const handleClearRecentSearches = () => {
    clearRecentSearches();
    callback();
  };

  return (
    <div
      data-testid={DataTestIdEnum.LOCATION_RECENT_SEARCHED_RESULTS}
      className="flex flex-col gap-4 w-full"
    >
      <div className="flex items-center justify-between">
        <Typography className="font-semibold">
          Pesquisas recentes
        </Typography>
        <Button
          data-testid={DataTestIdEnum.LOCATION_RECENT_SEARCHED_RESULTS_CLEAR}
          variant="text"
          className="text-sm w-fit"
          onClick={handleClearRecentSearches}
        >
          Limpar
        </Button>
      </div>
      <div
        data-testid={DataTestIdEnum.LOCATION_RECENT_SEARCHED_RESULTS_CONTAINER}
        className="flex flex-col gap-5"
      >
        {recentSearches.map((recentSearch, index) => (
          <ResultOption
            key={`key-recent-search-${recentSearch.placeId}-${index}`}
            description={recentSearch.description}
            callback={async () => {
              await handleLocationClick(recentSearch);
            }}
          />
        ))}
      </div>
    </div>
  );
};
